import { Util } from '@grandvisionhq/forms';

const validateInputField = (required, value, errorMessage, validations, validationsWithErrorMessages, maxLengthValue)=>{
    if (!required && value.length === 0) {
        return {
            isValid: true,
            errorMessage
        };
    }
    if (required) {
        if (!Util.validations.isRequired(value)) {
            return {
                isValid: false,
                errorMessage
            };
        }
    }
    if (maxLengthValue && !Util.validations.maxLength(maxLengthValue)(value)) {
        return {
            isValid: false,
            errorMessage
        };
    }
    if (validations) {
        const isValid1 = validations.reduce((isValid, validator)=>validator(value) && isValid
        , true);
        return {
            isValid: isValid1,
            errorMessage
        };
    }
    if (validationsWithErrorMessages) {
        for (const validatorWithErrorMessage of validationsWithErrorMessages){
            const isValid = validatorWithErrorMessage.validator(value);
            if (!isValid) {
                return {
                    isValid: false,
                    errorMessage: validatorWithErrorMessage.errorMessage
                };
            }
        }
    }
    return {
        isValid: true,
        errorMessage
    };
};

export { validateInputField };
//# sourceMappingURL=validate-input-field.js.map
